export default {
    added_to: 'Se agregó a',
    add_a_book: 'Añade un libro',
    buy_a_book: 'Compra un libro',
    choose_a_book_from_the_library: 'Escoge un libro desde la biblioteca.',
    collect_beecoins: 'Reúne BeeCoins y ve a la tienda por tu libro favorito.',
    delete_to: 'Borrado de',
    error_consulting_books: 'Hubo un error consultando libros.',
    my_list: 'Mi lista',
    no_books_found: '¡Ups! Aún no tienes libros aquí. ¡Ve y encuentra tu próxima aventura en la biblioteca!',
    search_result: 'Resultados para',
    title_carousel_1: 'Mi lista',
    title_carousel_2: 'Los 10 más populares',
    subtitle_carousel_2: 'Los 10 libros más leídos por nuestros lectores',
    title_carousel_3: 'Los 10 libros más buscados por nuestros lectores',
    title_carousel_4: 'Novedades',
    subtitle_carousel_4: 'Descubre las últimas publicaciones de la biblioteca',
    title_carousel_5: 'Mis lecturas',
    title_carousel_6: 'Recomendados para ti',
    subtitle_carousel_6: 'Nuestras recomendaciones para tu próximo viaje literario',
    title_carousel_7: 'Seguir leyendo',
    subtitle_carousel_7: 'Sigue tu lectura donde la dejaste',
    title_button_card: 'Leer',
    not_books_data: 'Sin libros para mostrar',
    book_tittle_required: 'El título del libro es requerido',
    more: 'Más',
    in: 'en'
}
